var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"min-width":"110","rounded":"","outlined":"","color":_vm.PRIMARYCOLOR},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t("simulator.buttons.previous"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }